import * as React from 'react';
import {usePopperTooltip} from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import {Fragment} from "react";

import './TooltipIconPasspoint.scss' ;
import {Link} from "react-router-dom";

const TooltipIcon = ({containerClassName='tooltip-container', arrowClassName='tooltip-arrow', ...props}) =>
{
    const defaultStyle = {
        marginLeft: '6px',
    }

    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible
    } = usePopperTooltip({placement: props.placement === undefined ? 'top' : props.placement, followCursor: true, offset: [0, 8], /*delayHide: 100000*/}, {});

    const renderComponent = () =>
    {
        if ( props.component !== undefined )
        {
            const IconWrapper = props.component ;

            const divStyle = { ...defaultStyle, display: 'inline'} ;

            if ( props.onClick !== undefined )
            {
                return <div ref={setTriggerRef} style={divStyle}><IconWrapper onClick={props.onClick} color={props.color} style={{cursor: 'pointer'}}/></div>
            }
            else if ( props.link !== undefined )
            {
                return <Link to={props.link}>
                    <div ref={setTriggerRef} style={divStyle}><IconWrapper onClick={props.onClick} color={props.color} style={{cursor: 'pointer'}}/></div>
                </Link>
            }
            else if ( props.href !== undefined )
            {
                return <a href={props.href} target={props.target}>
                    <div ref={setTriggerRef} style={divStyle}><IconWrapper onClick={props.onClick} color={props.color} style={{cursor: 'pointer'}}/></div>
                </a>
            }
            else
            {
                return <div ref={setTriggerRef} style={divStyle}><IconWrapper onClick={props.onClick} color={props.color} style={{cursor: 'pointer'}}/></div>
            }
        }
        else if ( props.link !== undefined )
        {
            return <Link to={props.link}>
                <span ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                                        className={'glyphicon ' + props.icon}/>
            </Link>
        }
        else if ( props.href !== undefined )
        {
            return <a href={props.href} target={props.target}><span ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                                                                    className={'glyphicon ' + props.icon}/></a>
        }
        else if ( props.onClick !== undefined )
        {
            return <span onClick={props.onClick} ref={setTriggerRef} style={{...defaultStyle, ...props.style, cursor: 'pointer', color: props.color}}
                         className={'glyphicon ' + props.icon}/>
        }
    }
    
    return (
        <Fragment>
            { renderComponent() }
            {visible && (
                <div ref={setTooltipRef} {...getTooltipProps({className: containerClassName})}>
                    {props.text}
                <div {...getArrowProps({className: arrowClassName})} />
                </div>
            )}
        </Fragment>
    )
}

export default TooltipIcon;
